import React, { useState, useEffect } from 'react'
import HeadingArea from '../../general/HeadingArea'
import UserLogo from '../../assets/user-logo.png';
import { FaCheck, FaPrint } from 'react-icons/fa';
import Select from 'react-select';
import ResponseMsg2 from '../../general/ResponseMsg2';
import { MdOutlineEdit } from 'react-icons/md';
// import { HiOutlineViewGrid } from 'react-icons/hi';
import Logo from '../../assets/logo.png';

const IssueReturn = ({setLoading}) => {
    const [members, setMembers] = useState([]);
const [searchTerm, setSearchTerm] = useState('');
const [showIssue, setShowIssue] = useState(false);
const [selectedMem, setSelectedMem] = useState('');
const [books, setBooks] = useState([]);
const [selectedBookId, setSelectedBookId] = useState('');
const [returnDate, setReturnDate] = useState('');
const [fine, setFine] = useState('');
const [issuedBooks, setIssuedBooks] = useState([]);
  const [response2, setResponse2] = useState({ message: '', status: 'success' });
  const [showEdit, setShowEdit] = useState(false);
const [selectedIssueId, setSelectedIssueId] = useState('');
const [lateOnDate, setLateOnDate] = useState('');
const [fineCollected, setFineCollected] = useState(false);
const [showView, setShowView] = useState(false);
const [selectedIssue, setSelectedIssue] = useState('');

               const fetchMember = async () => {
                            setLoading(true);
                    try {
                        const response = await fetch('https://api.kcian.in/libget-member');
        
                        if (response.ok) {
                            const data = await response.json();
                            setMembers(data);
                            setLoading(false);
                        } else {
                            setLoading(false);
                            console.error('Failed to fetch');
                        }
                    } catch (error) {
                        setLoading(false);
                        console.error('Error fetching data:', error);
                    }
      }


                     const fetchBooks = async () => {
                            setLoading(true);
                    try {
                        const response = await fetch('https://api.kcian.in/libget-books');
        
                        if (response.ok) {
                            const data = await response.json();
                            setBooks(data);
                            setLoading(false);
                        } else {
                            setLoading(false);
                            console.error('Failed to fetch');
                        }
                    } catch (error) {
                        setLoading(false);
                        console.error('Error fetching data:', error);
                    }
      }

         useEffect(() => {
      fetchMember();
      fetchBooks();
    }, []);


          const filteredMember = members.filter(m => {
  const term = searchTerm.toLowerCase();
  return (
    m.member_type.toLowerCase().includes(term) ||
    m.name.toLowerCase().includes(term) ||
    m.member_id.toLowerCase().includes(term)
  );
});


                     const fetchIssuedBook = async (memId) => {
                            setLoading(true);
                    try {
                        const response = await fetch(`https://api.kcian.in/libget-issuedbook/${memId}`);
        
                        if (response.ok) {
                            const data = await response.json();
// data.sort((a, b) => new Date(a.return_on) - new Date(b.return_on));
                            setIssuedBooks(data);
                            setLoading(false);
                        } else {
                            setLoading(false);
                            console.error('Failed to fetch');
                        }
                    } catch (error) {
                        setLoading(false);
                        console.error('Error fetching data:', error);
                    }
      }

const handleShowIssue = (mem) => {
setShowIssue(true);
setSelectedMem(mem);
fetchIssuedBook(mem.id);
}

const bookOptions = books.map(book => ({
  value: book.id,
  label: book.title,
}));


const handleSubmitIssue = async () => {
  if (!selectedBookId || !returnDate) {
    alert('Please select book and return date');
    return;
  }

   const selectedBook = books.find(book => book.id === selectedBookId);

  if (!selectedBook) {
    setResponse2({ message: 'Invalid Book Selection.', status: 'error' });
    return;
  }

  const availableQty = selectedBook.qty - selectedBook.issue_qty;

  if (availableQty <= 0) {
    setResponse2({ message: 'No Qty available to issue.', status: 'error' });
    return;
  }

  setLoading(true);

  const payload = {
    member_id: selectedMem.id,
    book_id: selectedBookId,
    return_date: returnDate,
    fine: fine || 0,
  };

  try {
    const response = await fetch('https://api.kcian.in/libissue-book', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    if (response.ok) {
        setResponse2({ message: 'Book Issued Successfully!', status: 'success' });
        fetchIssuedBook(selectedMem.id);
    } else {
                setResponse2({ message: 'Something Went Wrong. Please try again.', status: 'error' });
    }
  } catch (error) {
    console.error('Error issuing book:', error);
  } finally {
        setTimeout(() => {
          setResponse2('');
        }, 3000);   
    setLoading(false);
  }
};



const handleEdit = (book) => {
setShowEdit(true);
setSelectedIssueId(book.issue_id);
setSelectedBookId(book.book_id);
}


const handleView = (book) => {
setShowView(true);
  // console.log(selectedMem);

setSelectedIssue(book)
}


const handleEditSubmit = async () => {
  if (!lateOnDate) {
    alert('Please select a return date');
    return;
  }

  const payload = {
    issue_id: selectedIssueId,
    book_id: selectedBookId,
    late_on: lateOnDate,
    fine_collected: fineCollected ? 'Yes' : 'No',
  };

  try {
    setLoading(true);
    const response = await fetch('https://api.kcian.in/libreturn-book', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    if (response.ok) {
      setResponse2({ message: 'Return Successful.', status: 'success' });
      fetchIssuedBook(selectedMem.id);
      setShowEdit(false);
    } else {
      setResponse2({ message: 'Something went wrong.', status: 'error' });
    }
  } catch (error) {
    console.error('Return update error:', error);
    // setResponse2({ message: 'Server error', status: 'error' });
  } finally {
    setLoading(false);
    setSelectedBookId('');
    setTimeout(() => setResponse2(''), 3000);
  }
};

    const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    }).replace(',', '');
  };

    return (
<>

        <section className='py-4'>
            <div className='px-4'>
                <HeadingArea message1='Library' message2='Issue/Return Book' />

                    <div className='profile-card'>
                        <div className='d-md-flex d-sm-flex justify-content-between mb-2'>
                            <span className="profile-heading align-content-center">Issue Books</span>


                                <div className='profile-input-area ms-auto col-lg-3 border-0'>
                                    <input
                                        type='text'
                                        name='search'
                                        className='profile-input border-bottom rounded-0'
                                        placeholder='Search...'
  value={searchTerm}
  onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                </div>
                        </div>

                        <div className="table-responsive">
                            <table className="table w-100">
                                <thead className="account-thead rounded-4">

                                        <th className='rounded-start-4'>S No</th>
                                        <th>Name</th>
                                        <th>Member Id</th>
                                        <th>Type</th>
                                                                                <th>User Id</th>
                                        <th>Member Designation</th>
                                        <th>AY</th>
                                        <th>Class</th>
                                        <th className='rounded-end-4'>Activity</th>


                                </thead>
    {filteredMember.map((mem, index) => (
      <tr className='account-tr' key={mem.id}>
        <td>{index + 1}</td>
        <td>{mem.member_name || '--'}</td>
        <td>{mem.member_id || '--'}</td>
        <td>{mem.member_type}</td>
        <td>{mem.member_regno || '--'}</td>
        <td>{mem.member_des || '--'}</td>
        <td>{mem.member_ay || ''}</td>
        <td>{mem.member_class || ''} {mem.member_section || ''}</td>
        <td className='py-3 cursor-pointer'><span className='profile-btn2' onClick={() => handleShowIssue(mem)}>Issue/ Return Book</span>
        </td>
      </tr>
    ))}


                            </table>
                        </div>

                    </div>
            </div>
        </section>


{showIssue && selectedMem && (
    <>
        <section className='ins-dialog'>
          <div className='col-lg-11 col-12 animate__animated animate__fadeInDown ms-auto' onClick={(e) => e.stopPropagation()}>

            <button className='profile-btn2' onClick={() => setShowIssue(false)}>Go Back</button>



<div className='row mt-2'>

<div className='col-lg-3 col-md-5 col-12 my-2'>

    <div className='profile-card'>
<div className='text-center'>
<img
src={
    selectedMem.profile_pic && selectedMem.profile_pic.trim() !== ''
      ? `https://api.kcian.in/inUploads/${selectedMem.profile_pic}`
      : UserLogo
  } className='emp-img' alt={selectedMem.name} />

<p className='emp-name2'>{selectedMem.name}</p></div>

<div className='bg-light px-3 py-3 rounded-4'>
<span className='profile-text'>Name</span><br />
<span className='profile-text border-0'><i class="fa-solid fa-arrow-turn-up fa-rotate-90"></i> {selectedMem.member_name}</span><br />

<span className='profile-text'>Member Id</span><br />
<span className='profile-text border-0'><i class="fa-solid fa-arrow-turn-up fa-rotate-90"></i> {selectedMem.member_id}</span><br />

<span className='profile-text'>Member Type</span><br />
<span className='profile-text border-0'><i class="fa-solid fa-arrow-turn-up fa-rotate-90"></i> {selectedMem.member_type}</span><br />

<span className='profile-text'>Mobile</span><br />
<span className='profile-text border-0'><i class="fa-solid fa-arrow-turn-up fa-rotate-90"></i> {selectedMem.member_mobile}</span><br />

</div>
</div>
{/* left top ends */}

                    <p className='profile-heading my-3'>Issue Book</p>

    <div className='profile-card'>

<div className='profile-input-area my-3 border-0'>
  <label htmlFor="book-select" className='profile-badge'>Select Book</label>
 <Select
  options={bookOptions}
  value={bookOptions.find(option => option.value === selectedBookId) || null}
  onChange={(selectedOption) => setSelectedBookId(selectedOption ? selectedOption.value : '')}
  placeholder="Select Book..."
  className='profile-input'
  isClearable
/>

</div>


<div className='profile-input-area mb-4'>
  <label className='profile-badge'>Return Date</label>
  <input
    type="date"
    className="profile-input"
    value={returnDate}
    onChange={(e) => setReturnDate(e.target.value)}
    required
  />
  </div>


<div className='profile-input-area mb-4'>
  <label className='profile-badge'>Fine (₹)</label>
  <input
    type="number"
    min="0"
    className="profile-input"
    placeholder="Enter fine amount"
    value={fine}
    onChange={(e) => setFine(e.target.value)}
  />
  </div>

       {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}

                        <div className='col-12 text-center'>
  <button
    className="profile-btn"
    onClick={handleSubmitIssue}
      >
    <FaCheck /> Issue Now
  </button></div>

</div>
{/* issue book form ends */}
</div>
{/* left ends */}



<div className='col-lg-9 col-md-7 col-12 my-2'>
       {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}
{showEdit && (
  <>
<div className="profile-card mb-3">
  <p className="profile-heading">Return Book</p>

  <div className="profile-input-area my-3">
    <label className="profile-badge">Returned On</label>
    <input
      type="date"
      className="profile-input"
      value={lateOnDate}
      onChange={(e) => setLateOnDate(e.target.value)}
    />
  </div>

  <div className="profile-input-area border-0">
    <input
      className="form-check-input fs-4 mt-1 me-3"
      type="checkbox"
      checked={fineCollected}
      onChange={(e) => setFineCollected(e.target.checked)}
      id="fineCollectedCheck"
    />
    <label className="profile-badge mt-3" htmlFor="fineCollectedCheck">
      Fine Collected 
    </label>
  </div>

  <div className="text-end">
    <button className="profile-btn2 me-2" onClick={() => setShowEdit(false)}>Cancel</button>
    <button className="profile-btn" onClick={handleEditSubmit}>Submit</button>
  </div>
</div>

  </>
)}


<p className='emp-name2'> Issued Books</p>
<div className='profile-card'>


                        <div className="table-responsive">
                            <table className="table w-100">
                                <thead className="account-thead rounded-4">

                                        <th className='rounded-start-4'>S No</th>
                                        <th>Title/ Book No</th>
                                        <th>Issue On</th>
                                        <th>Return By</th>
                                        <th>Late Fine</th>
                                                                                <th>Status</th>
                                        <th>Fine Collected</th>
                                        <th className='rounded-end-4'>Activity</th>
                                </thead>


{issuedBooks.map((book, index) => (
      <tr className='account-tr' key={book.id}>
        <td>{index + 1}</td>
        <td>{book.title}/ {book.book_no}</td>
        <td>{book.issue_on
  ? new Intl.DateTimeFormat('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    }).format(new Date(book.issue_on))
  : '--'}
</td>
        <td>{book.return_on
  ? new Intl.DateTimeFormat('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    }).format(new Date(book.return_on))
  : '--'}
</td>
        <td>₹ {book.fine || '--'}</td>
        <td>{book.late_on == null ? 'Issued' : 'Returned'}</td>
                        <td>{book.fine_collected || '--'}</td>

    <td>
      {book.late_on == null && 
      <MdOutlineEdit className='account-icon1 text-light' onClick={() => handleEdit(book)} size={28} title='Edit' />} &nbsp;&nbsp;
    <FaPrint className='account-icon2 text-light' onClick={() => handleView(book)} size={28} title='Print Receipt' /></td>
      </tr>
    ))}

                                </table>
                                </div>



</div>
</div>



</div>
{/* row ends */}

</div>
</section>

    </>
)}



{showView && (
  <>

        <section className='ins-dialog'>
          <div className='ins-dialog-inner col-lg-10 col-12 animate__animated animate__fadeInDown mx-auto' onClick={(e) => e.stopPropagation()}>

      <div className="d-flex justify-content-between">
        <p className="profile-heading my-0">
        {selectedIssue.late_on == null ? 'Issued' : 'Returned'}  Book Receipt
        </p>

                  <button className='profile-btn2' onClick={() => setShowView(false)}>Go Back</button>

      </div>
            {/* <p className='ins-dialog-heading text-danger'>Book Issue Details!</p> */}

      <div className="text-center border col-lg-6 col-md-7 col-12 mx-auto my-3" id="receipt-area">

<div className='receipt-logo-area' >
<img src={Logo} alt='Watermark' className='receipt-logo' /></div>


  <p className="mt-3 mb-0 profile-heading fs-5 fw-bold">
          K. C. Public School
        </p>
        <p>
          (C.B.S.E. Affiliation No. 1530116)
          <br />Tata Benz Square, Berhampur
        </p>

        <p className="fw-bold fs-5">BOOK RECEIPT</p>


            <div className="d-flex justify-content-between fw-semibold border-top p-2">
          <span className='para-text'>Receipt No. {selectedIssue.issue_id}</span>
<span className='para-text'>Generated On: {formatDateTime(new Date().toISOString())}</span>        </div>


        <div className="border-top border-bottom p-2 text-start fw-semibold para-text">
          <span>
            Member Id. {selectedMem.member_id}
            <br />
            {selectedMem.member_type} Name: {selectedMem.name}
          </span>
        </div>

        <div className="d-flex justify-content-between fw-semibold p-2 para-text">
          {selectedMem.member_type == 'Student' ? 
          <>
          
          <span>Class: {selectedMem.member_class}</span>
          <span>Section: {selectedMem.member_section}</span></>
          :           <span>Designation: {selectedMem.member_des}</span>
}

        </div>

        <div className="table-responsive">
          <table className="w-100 table border text-start">

            <thead>
              <tr>
                <th className="p-2">Book Details</th>
                <th className="p-2">Issue On</th>
                <th className="p-2">Return By</th>
              </tr>
            </thead>

            <tbody>

                <tr>
                  <td className="p-2">{selectedIssue.title}/ {selectedIssue.book_no}</td>
                  <td className="p-2">{selectedIssue.issue_on
  ? new Intl.DateTimeFormat('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    }).format(new Date(selectedIssue.issue_on))
  : '--'}</td>
                    <td className="p-2">{selectedIssue.return_on
  ? new Intl.DateTimeFormat('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    }).format(new Date(selectedIssue.return_on))
  : '--'}</td>
                </tr>


            </tbody>



</table>
</div>
{/* table ends */}

        <div className="px-2 pb-2 d-flex justify-content-between fw-semibold para-text">
<span>Returned On: {selectedIssue.late_on
  ? new Intl.DateTimeFormat('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    }).format(new Date(selectedIssue.late_on))
  : '--'}</span>

<span>Fine Collected: ₹ {selectedIssue.fine}</span>
</div>

</div>


<div className='text-center'>
<button className='profile-btn' onClick={() => window.print()}>Print Receipt</button>
</div>


    </div>
  </section>

  </>
)}


</>
    )
}

export default IssueReturn